import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectionService, ConnectionState } from '../../services/network.service';

@Component({
    selector: 'app-internet-status-banner',
    templateUrl: './internet-status-banner.component.html',
    styleUrls: ['./internet-status-banner.component.scss']
})
export class InternetStatusBannerComponent implements OnInit, OnDestroy {
    state: ConnectionState = {
        hasNetworkConnection: true,
        hasInternetAccess: true,
        isRequestInProgress: false
    };
    private sub: Subscription = new Subscription();

    get showBanner(): boolean {
        return !this.state.hasInternetAccess;
    }

    constructor(private connectionService: ConnectionService) { }

    ngOnInit(): void {
        this.sub.add(
            this.connectionService.stateChanged$.subscribe((state: ConnectionState) => {
                this.state = state;
            })
        );
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
